/**
 * GUI 클리핑 설정 (4개 모서리 삼각형)
 * - GUICornerTriangles와 GUIClippingManager가 공유
 */

export interface GUICornerConfig {
  enabled: boolean;
  controlPoint: number; // 0~1, 모서리에서 시작하는 빗변의 제어점
  color: string; // 삼각형 배경색
  zIndex: number; // 렌더링 순서
  // 텍스처 및 페이드 그라디언트 설정
  textureIntensity?: number; // 텍스처 강도 (0~1), 기본값 0.4
  fadeEnabled?: boolean; // 그라디언트 활성화 여부, 기본값 true
  fadeStart?: number; // 페이드 시작점 (0~1, 0=빗변, 1=모서리), 기본값 0.0
  fadeEnd?: number; // 페이드 끝점 (0~1), 기본값 0.85
  fadeMinAlpha?: number; // 모서리 쪽 알파값 (0~1), 기본값 0.3
  fadeMaxAlpha?: number; // 빗변 쪽 알파값 (0~1), 기본값 1.0
  fadeKnot?: number; // 그라디언트 완료 지점 (0~1), 기본값 0.5
}

export interface GUIClippingConfig {
  topLeft: GUICornerConfig;
  topRight: GUICornerConfig;
  bottomLeft: GUICornerConfig;
  bottomRight: GUICornerConfig;
}

/**
 * GUI 클리핑 기본 설정 (다크 모드 전용)
 */
export const GUI_CONFIG: GUIClippingConfig = {
  topLeft: {
    enabled: false, // 2D UI 사용 (OverlayCanvas 미사용)
    controlPoint: 0.5,
    color: "#3d4a3d",
    zIndex: -90,
    textureIntensity: 0.4,
    fadeEnabled: true,
    fadeStart: 0.0,
    fadeEnd: 0.85,
    fadeMinAlpha: 0.3,
    fadeMaxAlpha: 1.0,
    fadeKnot: 0.01,
  },
  topRight: {
    enabled: true,
    controlPoint: 0.5,
    color: "#d97706", // 주황색
    zIndex: -100,
    textureIntensity: 0.4,
    fadeEnabled: true,
    fadeStart: 0.0,
    fadeEnd: 0.85,
    fadeMinAlpha: 0.3,
    fadeMaxAlpha: 1.0,
    fadeKnot: 0.01,
  },
  bottomLeft: {
    enabled: false,
    controlPoint: 0.5,
    color: "#d97706", // 갈색
    zIndex: -100,
    textureIntensity: 1.0,
    fadeEnabled: true,
    fadeStart: 0.0,
    fadeEnd: 0.85,
    fadeMinAlpha: 0.3,
    fadeMaxAlpha: 1.0,
    fadeKnot: 0.01,
  },
  bottomRight: {
    enabled: true,
    controlPoint: 0.5,
    color: "#686e3fff",
    zIndex: -90,
    textureIntensity: 1.0,
    fadeEnabled: false,
    fadeStart: 0.0,
    fadeEnd: 0.85,
    fadeMinAlpha: 1.0,
    fadeMaxAlpha: 1.0,
    fadeKnot: 0.01,
  },
};

// 레거시 호환용 별칭
export const DARK_MODE_GUI_CONFIG = GUI_CONFIG;

/**
 * GUI 클리핑 설정 반환 (항상 다크 모드)
 */
export function getGUIClippingConfig(): GUIClippingConfig {
  return GUI_CONFIG;
}
